var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mingcute:notification-line",
    clipPath: "url(#clip0_465_1791)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9999 12.6666C10 13.003 9.87296 13.327 9.64423 13.5736C9.41551 13.8203 9.102 13.9714 8.76657 13.9966L8.66657 13.9999H7.33323C6.99685 14 6.67285 13.873 6.4262 13.6443C6.17955 13.4155 6.02846 13.102 6.00323 12.7666L5.9999 12.6666H9.9999ZM7.9999 1.33325C9.20989 1.33323 10.3726 1.80318 11.2427 2.64397C12.1129 3.48476 12.6224 4.63064 12.6639 5.83992L12.6666 5.99992V8.50925L13.8812 10.9386C13.9342 11.0446 13.9608 11.1619 13.9585 11.2803C13.9563 11.3988 13.9254 11.515 13.8685 11.619C13.8115 11.7229 13.7302 11.8115 13.6316 11.8771C13.5329 11.9428 13.4198 11.9835 13.3019 11.9959L13.2252 11.9999H2.77457C2.65601 12 2.53921 11.9712 2.43418 11.9162C2.32915 11.8613 2.23902 11.7816 2.17151 11.6842C2.104 11.5867 2.06113 11.4743 2.04657 11.3567C2.03201 11.239 2.04619 11.1196 2.0879 11.0086L2.11857 10.9386L3.33323 8.50925V5.99992C3.33323 4.76224 3.8249 3.57526 4.70007 2.70009C5.57524 1.82492 6.76222 1.33325 7.9999 1.33325ZM7.9999 2.66659C7.14092 2.66663 6.31512 2.99828 5.69471 3.59236C5.0743 4.18644 4.70718 4.99709 4.6699 5.85525L4.66657 5.99992V8.50925C4.66657 8.67459 4.63583 8.83849 4.5759 8.99259L4.5259 9.10592L3.7459 10.6666H12.2546L11.4746 9.10525C11.4006 8.95744 11.3547 8.79716 11.3392 8.63259L11.3332 8.50925V5.99992C11.3332 5.11586 10.982 4.26802 10.3569 3.6429C9.7318 3.01777 8.88395 2.66659 7.9999 2.66659Z",
    fill: "#292D32"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_465_1791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell_icon.e39e1c586e972764a33fef1e811899af.svg";
export { ForwardRef as ReactComponent };